import { Table } from 'uikit';

import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { useTableTreeLeftFilterVersColumns } from './hooks/useTableTreeLeftFilterVersColumns';

import Style from './LeftFilterVersionStructure.module.css';

interface ILeftFilter {
    items?: any;
    onRowSelected?: (itemId: number) => void;
    selectedId?: number;
}

export const LeftVersionStructureFilter: React.FC<ILeftFilter> = (props) => {
    const { items = [], selectedId, onRowSelected } = props;

    const columns = useTableTreeLeftFilterVersColumns();
    const [selectedRowId, setSelectedRowId] = useState(selectedId);

    useEffect(() => {
        setSelectedRowId(selectedId);
    }, [selectedId]);

    const onRowClick = useCallback(
        ({ id }) => {
            setSelectedRowId(id);
            onRowSelected?.(id);
        },
        [onRowSelected],
    );

    const getAdditionalClassName = useCallback(
        ({ row }) => (String(selectedRowId) === String(row.id) ? 'selected' : ''),
        [selectedRowId],
    );

    return (
        <Table
            columns={columns as any}
            rows={items as any}
            size="s"
            stickyHeader
            borderBetweenColumns
            verticalAlign="center"
            onRowClick={onRowClick}
            className={Style.leftFilter}
            getAdditionalClassName={getAdditionalClassName}
        />
    );
};

LeftVersionStructureFilter.displayName = 'LeftVersionStructureFilter';
